export const en = {
  'adminArea.noAccessTitle': 'You do not have access to this area',
  'adminArea.noAccessDescription': 'Ask a gym owner or admin to grant you the required permission.',
  'adminArea.goBack': 'Go back',
  'adminArea.nothingTitle': 'Nothing to show',
  'adminArea.nothingDescription': 'Your role has no admin permissions at this gym.',
  'adminArea.chooseGym': 'Choose a gym',
  'adminArea.chooseGymDescription': 'This account can manage more than one gym. Pick the one you want to work on.',
  'adminArea.noStaffGyms': 'You are not staff at any gym yet.',
  'adminArea.platformConsole': 'Open the platform console',
  'adminArea.notFoundTitle': 'Page not found',
  'adminArea.notFoundDescription': 'This admin page does not exist.',
  'adminArea.backToDashboard': 'Back to dashboard',
  'adminArea.copy': 'Copy',
  'adminArea.copyPrompt': 'Copy this value',

  'staff.title': 'Staff',
  'staff.description': 'People who can sign in to this admin area.',
  'staff.invite': 'Invite',
  'staff.roleUpdated': 'Role updated',
  'staff.removed': 'Staff member removed',
  'staff.emptyTitle': 'No staff yet',
  'staff.emptyDescription': 'Invite your team so they can manage members and classes.',
  'staff.role': 'Role',
  'staff.since': 'Since',
  'staff.you': '(you)',
  'staff.remove': 'Remove',
  'staff.removeTitle': 'Remove staff member?',
  'staff.removeDescription': '{name} will lose access to the admin area immediately.',
  'staff.pendingTitle': 'Pending invitations',
  'staff.pendingDescription': 'Links that have not been accepted yet. Inviting the same email again replaces its earlier link.',
  'staff.pendingEmptyTitle': 'No pending invitations',
  'staff.pendingEmptyDescription': 'People you invite appear here until they accept.',
  'staff.invitedBy': 'Invited by',
  'staff.sent': 'Sent',
  'staff.expires': 'Expires',
  'staff.revoke': 'Revoke',
  'staff.revoked': 'Invitation revoked',
  'staff.revokeTitle': 'Revoke invitation?',
  'staff.revokeDescription': 'The link sent to {email} will stop working immediately.',
  'staff.inviteTitle': 'Invite a team member',
  'staff.inviteDescription': 'They will receive an email with a link to create their account.',
  'staff.done': 'Done',
  'staff.sendInvite': 'Send invite',
  'staff.attachedExisting': 'This person already had a Bulk account, so they were added to the team directly.',
  'staff.inviteSent': 'Invitation sent. If email is not set up yet, share this link with them directly:',
  'staff.firstName': 'First name',
  'staff.lastName': 'Last name',
  'staff.roleHint': 'Admins set the gym up: its settings, integrations, roles and abilities, and the audit log are theirs alone. Owners and gym general managers can change everything else, and only an owner or an admin adds an owner, a gym general manager or an HR manager. An HR manager runs the team: staff accounts below the gym general manager, records, leave, schedules, hours and hiring, never members or money. A branch manager runs their branches and their staff; a shift manager runs a shift. Staff and reception run the front desk; accountants read the back office; trainers manage their classes.',
  'practice.banner': 'Practice gym: the members, money and doors here are made up. Nothing you do here reaches {gym}.',
  'practice.backToReal': 'Back to the real gym',
  'practice.title': 'Practice gym',
  'practice.description': 'A made-up gym where new staff practise selling memberships, checking people in, the bar and refunds. Everyone on the team can enter it with their own role, and nothing in it reaches real money, members, email or doors.',
  'practice.none': 'No practice gym yet.',
  'practice.create': 'Create practice gym',
  'practice.created': 'Practice gym ready',
  'practice.open': 'Open practice gym',
  'practice.reset': 'Reset practice gym',
  'practice.resetTitle': 'Reset the practice gym?',
  'practice.resetBody': 'Everything trainees did there is replaced with a fresh made-up gym. The real gym is not touched.',
  'practice.resetDone': 'Practice gym reset',
  'practice.summary.one': 'Made {date} · {count} made-up member',
  'practice.summary.other': 'Made {date} · {count} made-up members',
  'practice.cards': 'Made-up cards to try at the desk and the door: PRACTICE-0001 to {last}.',
  'practice.edit': 'Change figures',
  'practice.delete': 'Delete practice gym',
  'practice.deleteTitle': 'Delete the practice gym?',
  'practice.deleteBody': 'The team can no longer enter it, and its made-up members, sales and visits go with it. The real gym is not touched, and you can create a new one at any time.',
  'practice.deleted': 'Practice gym deleted',
  'practice.chooseFigures': 'Choose the figures first',
  'practice.makeup.createTitle': 'Create a practice gym',
  'practice.makeup.editTitle': 'Change the practice gym',
  'practice.makeup.rebuildNote': 'Saving builds the practice gym again with these figures: everything trainees did there is replaced. The real gym is not touched.',
  'practice.makeup.saveRebuild': 'Save and rebuild',
  'practice.makeup.members': 'Members',
  'practice.makeup.branches': 'Branches',
  'practice.makeup.active': 'Active membership',
  'practice.makeup.endingSoon': 'Ending within a week',
  'practice.makeup.expired': 'Expired membership',
  'practice.makeup.withoutMembership': 'No membership',
  'practice.makeup.withBalance': 'With a bar balance',
  'practice.makeup.total.one': '{count} made-up member in all',
  'practice.makeup.total.other': '{count} made-up members in all',
  'practice.makeup.whole': 'Use whole numbers, 0 or more.',
  'practice.makeup.branchesRange': 'A practice gym has 1 to {max} branches.',
  'practice.makeup.membersRange': 'A practice gym has 1 to {max} members.',
  'practice.makeup.balanceTooMany': 'More members with a balance than members.',
  'practice.inside': 'You are in the practice gym. It is created and reset from the real gym.',
  'viewAs.label': 'View the admin as',
  'viewAs.self': '{role} (you)',
  'viewAs.as': 'View as {role}',
  'viewAs.banner': 'You are working as {role}: you see and can do only what that role can. Your changes are still recorded as yours.',
  'viewAs.back': 'Back to {role}',
  'viewAs.member.option': 'View the member area as…',
  'viewAs.member.title': 'View the member area',
  'viewAs.member.description': "Pick one of the practice gym's made-up members. You see their member area as they would and can do what they can. What you do is recorded as yours.",
  'viewAs.member.search': 'Search by name or member number',
  'viewAs.member.none': 'No member matches.',
  'viewAs.member.number': 'No. {number}',
  'viewAs.member.banner': 'You are viewing the member area as {name} (No. {number}), a made-up member of the practice gym. What you do here is recorded as yours.',
  'viewAs.member.stop': 'Stop viewing',

  'abilities.changed': 'Changed',
  'abilities.turnedOn': '{ability}: on for {role}',
  'abilities.turnedOff': '{ability}: off for {role}',
  'abilities.menu.edit': 'Edit the bar menu',
  'abilities.menu.edit.hint': 'Add, change, hide and remove items and categories. Every branch sells from the one menu.',
  'abilities.website.publish': 'Publish the website',
  'abilities.website.publish.hint': 'Put website changes live for visitors.',
  'abilities.legal.publish': 'Publish legal pages',
  'abilities.legal.publish.hint': 'Put terms, privacy and the other documents live.',
  'abilities.campaigns.run': 'Run campaigns',
  'abilities.campaigns.run.hint': 'Create, change and end discount campaigns.',
  'abilities.campaigns.email': 'Send campaigns by email',
  'abilities.campaigns.email.hint': 'Email a live campaign to members who agreed to offers by email, through the gym’s own email account.',
  'abilities.campaigns.sms': 'Send campaigns by SMS',
  'abilities.campaigns.sms.hint': 'Text a live campaign to members who agreed to offers by SMS; each text is charged to the gym.',
  'abilities.staff.manage': 'Manage staff accounts at their branches',
  'abilities.staff.manage.hint': 'Invite, change and remove the people below them at their own branches.',
  'abilities.payments.refund': 'Refund payments',
  'abilities.payments.refund.hint': 'Approve or reject refund requests and refund a payment directly.',
  'abilities.wallet.correct': 'Correct balances',
  'abilities.wallet.correct.hint': 'Fix a mistake in a member’s balance; the reason is kept with the change.',
  'abilities.refunds.request': 'Send refund requests',
  'abilities.refunds.request.hint': 'Ask for a payment to be refunded; someone who refunds approves it.',
  'abilities.wallet.top_up': 'Top up balances',
  'abilities.wallet.top_up.hint': 'Take money at the desk and add it to a member’s balance.',
  'abilities.bar.sell': 'Sell at the bar',
  'abilities.bar.sell.hint': 'Ring up sales at the bar till.',
  'abilities.bar.refund': 'Refund bar sales',
  'abilities.bar.refund.hint': 'Give the money back for a bar sale.',
  'abilities.bar.stock': 'Count stock',
  'abilities.bar.stock.hint': 'Receive deliveries and count what is on the shelf.',
  'abilities.classes.edit': 'Schedule every class',
  'abilities.classes.edit.hint': 'Add and change any class, slot and session, for any trainer. Without it a trainer schedules only the classes they teach.',
  'abilities.finance.close_month': 'Close finance months',
  'abilities.finance.close_month.hint': 'Close a month once it is over and every task is done or skipped.',
  'abilities.expenses.drawer': 'Pay expenses from the drawer',
  'abilities.expenses.drawer.hint': 'Pay small expenses in cash from the open desk drawer; the shift then expects that much less cash.',
  'abilities.trainers.roster': 'Keep the trainer roster',
  'abilities.trainers.roster.hint': 'Add and deactivate trainers, and set their names, contacts, specialities and staff photo.',
  'abilities.trainers.website': "Shape trainers' website profiles",
  'abilities.trainers.website.hint': 'Website photo, names and bios in both languages, who shows on the website and in what order.',
  'abilities.schedules.manage': 'Manage schedules at their branches',
  'abilities.schedules.manage.hint': 'See the team roster, give people schedules, change single days and approve shift swaps at their own branches.',
  'abilities.leave.decide': 'Decide leave at their branches',
  'abilities.leave.decide.hint': 'Approve or refuse the leave of the people below them at their own branches, and record it for them.',
  'abilities.plans.edit': 'Edit membership plans',
  'abilities.plans.edit.hint': 'Create, change and archive membership plans: name, price, duration, hours and classes. The owner can switch this too, from the Plans page.',
  'abilities.appointments.book_for_member': 'Book sessions for members',
  'abilities.appointments.book_for_member.hint': 'Book a member into their own one-to-one time, confirmed at once. A session comes off the member’s package, or they pay at the desk.',
  'abilities.tags.manage': 'Manage the tag list',
  'abilities.tags.manage.hint': 'Add, rename, recolour and delete the gym’s member tags, not only put them on members.',

  'audit.title': 'Audit log',
  'audit.description': 'Every change made by staff, integrations and the system.',
  'audit.entity': 'Entity',
  'audit.entityPlaceholder': 'e.g. member, membership, plan',
  'audit.action': 'Action',
  'audit.actionPlaceholder': 'e.g. member.created',
  'audit.emptyTitle': 'No audit entries',
  'audit.emptyDescription': 'Nothing matches these filters yet.',
  'audit.when': 'When',
  'audit.actor': 'Actor',
  'audit.details': 'Details',
  'audit.system': 'system',
  'audit.metadata': 'metadata',

  'integrations.title': 'Integrations',
  'integrations.description': 'Connect the services the gym runs on. Each one is tested before it goes live.',
  'integrations.blurb.PAYMENT': 'Online checkout for memberships, refunds and bank callbacks.',
  'integrations.blurb.ACCESS_CONTROL': 'Turnstiles, doors and readers that check memberships at the door.',
  'integrations.blurb.EMAIL': 'Receipts, reminders and staff invitations.',
  'integrations.blurb.SMS': 'Texts members about cancelled or changed classes, memberships about to end, and their sign-in link.',
  'integrations.smsTestNumber': 'Mobile number for a test text',
  'integrations.smsTestSend': 'Send test text',
  'integrations.smsTestHint': 'A real text, charged like any other. It shows the sender name is approved before members depend on it.',
  'integrations.emailQueued': 'Emails wait in the queue and go out once your own email account is connected and tested.',
  'integrations.emailViaPlatform': 'Until your own email account is connected and tested, emails go out through Bulk from {fromEmail} as "{gymName} via {brand}". Replies go to the gym email from Settings → Profile when one is set.',
  'integrations.yourGym': 'Your gym',
  'integrations.testConnected': 'Connected: {message}',
  'integrations.testFailed': 'Test failed: {message}',
  'integrations.disconnected': 'Integration disconnected',
  'integrations.enabled': 'Enabled',
  'integrations.connectedAt': 'Connected',
  'integrations.lastChecked': 'Last checked',
  'integrations.never': 'Never',
  'integrations.notConfigured': 'Not configured yet.',
  'integrations.webhookUrl': 'Webhook URL',
  'integrations.configure': 'Configure',
  'integrations.reconfigure': 'Reconfigure',
  'integrations.test': 'Test',
  'integrations.logs': 'Logs',
  'integrations.disconnect': 'Disconnect',
  'integrations.disconnectTitle': 'Disconnect integration?',
  'integrations.disconnectDescription': 'The provider is turned off, its status is reset and its stored credentials are deleted, so it has to be set up again. The on-site door agent stops working until it is set up again with a new token.',
  'integrations.logsTitle': '{kind} logs',
  'integrations.logsEmpty': 'No log entries yet',
  'integrations.when': 'When',
  'integrations.level': 'Level',
  'integrations.operation': 'Operation',
  'integrations.message': 'Message',
  'integrations.duration': 'Duration',
  'integrations.durationMs': '{ms} ms',
  'integrations.agentCommands': 'Agent commands',
  'integrations.agentCommandsDescription': 'Commands queued for the on-site access agent, newest first.',
  'integrations.agentCommandsEmptyTitle': 'No commands yet',
  'integrations.agentCommandsEmptyDescription': 'Remote-open and sync commands show up here once sent.',
  'integrations.created': 'Created',
  'integrations.type': 'Type',
  'integrations.acknowledged': 'Acknowledged',
  'integrations.result': 'Result',
  'integrations.configSaved': 'Configuration saved',
  'integrations.continue': 'Continue',
  'integrations.saveConfig': 'Save configuration',
  'integrations.testAgain': 'Test again',
  'integrations.testConnection': 'Test connection',
  'integrations.done': 'Done',
  'integrations.configureTitle': 'Configure {kind}',
  'integrations.current': 'Current',
  'integrations.secretsNote': 'Secrets are stored encrypted. Leave a secret blank to keep the current value.',
  'integrations.savedRunTest': '{provider} · saved. Run a connection test to enable it.',
  'integrations.connectionOk': 'Connection OK',
  'integrations.connectionFailed': 'Connection failed',
  'integrations.webhookHint': 'Register this callback URL in the bank’s merchant portal.',
  'integrations.smsReportUrl': 'Delivery report address',
  'integrations.smsReportHint': 'Ask smsoffice.ge to send delivery reports to this address. Until then Bulk asks about each text itself, and the reason a text did not arrive is not known.',
  'integrations.texts': 'Texts',
  'integrations.textsTitle': 'Texts sent',
  'smsLog.when': 'When',
  'smsLog.member': 'Member',
  'smsLog.text': 'Text',
  'smsLog.delivery': 'Reached the phone',
  'smsLog.noReport': 'No report yet',
  'smsLog.nextTry': 'Next try {when}',
  'smsLog.problemsOnly': 'Only texts that failed or did not arrive',
  'smsLog.empty': 'No texts yet',
  'smsLog.emptyHint': 'Texts about classes, memberships, invitations and offers show here once they go out.',
  'smsLog.noProblems': 'Every text arrived or is still on its way',
  'integrations.stepProvider': 'Provider',
  'integrations.stepSettings': 'Settings',
  'integrations.generatedOnSave': 'Will be generated on save',
  'integrations.keepSecret': 'Leave blank to keep the stored secret.',
  'integrations.agent.title': 'On-site agent setup',
  'integrations.agent.install': 'Install {path} on a machine inside the gym network that can reach the Gantner controllers.',
  'integrations.agent.env': 'Set these environment variables for the agent process:',
  'integrations.agent.tokenOnce': 'Copy this token now: it is shown only this once and will not be shown again. The previous token no longer works, so the agent on site stays offline until it is started with this one.',
  'integrations.agent.tokenMasked': 'The agent token is stored encrypted and is never shown again. To get one for the agent, rotate it: Bulk makes a new token, shows it once, and the current one stops working at once.',
  'integrations.agent.rotate': 'Rotate and show token',
  'integrations.agent.rotateTitle': 'Rotate the agent token?',
  'integrations.agent.rotateDescription': 'A new token replaces the current one at once. The agent on site stops working until you give it the new token. The new token is shown once, right after you confirm.',
  'integrations.agent.rotated': 'New agent token created',
  'admin.apiError.NOT_AN_AGENT': 'Access control is not connected to an on-site agent, so there is no agent token to replace. Set up the agent first.',
  'integrations.agent.driver': 'Choose the driver. Leave {mock} to simulate lanes, or set {rabbit} to bridge the GANTNER/Lapis controller over the on-site RabbitMQ and also set:',
  'integrations.agent.controllerIds': "Find the facility id, the opening-staff id and each lane's device id and IP in the controller (Lapis) configuration. Keep the RabbitMQ password out of shared files.",
  'integrations.agent.start': 'Start the agent. It registers its readers automatically; they appear under Access control → Readers.',
  'integrations.agent.test': 'Run the connection test above — it succeeds once the agent has sent a heartbeat.',
  'integrations.providers.paymentMock': 'For testing. Members land on a fake bank page where you choose the outcome.',
  'integrations.providers.tbc': 'TBC e-commerce checkout (cards, Apple Pay, Google Pay).',
  'integrations.providers.bog': 'Bank of Georgia iPay checkout.',
  'integrations.providers.accessMock': 'Simulated readers for testing the access flow without hardware.',
  'integrations.providers.enviso': 'Cloud access control by Enviso.',
  'integrations.providers.gantner': 'Gantner GT7 lanes on the gym network, bridged by the Bulk access agent over the on-site RabbitMQ.',
  'integrations.providers.console': 'Emails are logged instead of sent.',
  'integrations.providers.smtp': 'Any SMTP server (Google Workspace, Office 365, Mailgun, …).',
  'integrations.providers.resend': 'Transactional email API by Resend.',
  'integrations.providers.consoleSms': 'Text messages are logged instead of sent.',
  'integrations.providers.smsoffice': 'The Georgian SMS gateway smsoffice.ge. Needs an account with a balance and a registered sender name.',
  'integrations.fields.autoComplete': 'Auto-complete payments',
  'integrations.fields.autoCompleteHint': 'Skip the fake bank page and mark payments as paid immediately.',
  'integrations.fields.apiKey': 'API key',
  'integrations.fields.clientId': 'Client ID',
  'integrations.fields.clientSecret': 'Client secret',
  'integrations.fields.baseUrl': 'API base URL',
  'integrations.fields.callbackAllowedIps': 'Callback allowed IPs',
  'integrations.fields.callbackAllowedIpsHint': 'Comma separated. Webhook calls from other addresses are rejected.',
  'integrations.fields.tokenUrl': 'OAuth token URL',
  'integrations.fields.verifyCallbackSignature': 'Verify callback signatures',
  'integrations.fields.simulateProviderErrors': 'Simulate provider errors',
  'integrations.fields.apiSecret': 'API secret',
  'integrations.fields.tenantKey': 'Tenant key',
  'integrations.fields.environment': 'Environment',
  'integrations.fields.agentToken': 'Agent token',
  'integrations.fields.agentTokenHint': 'Generated by the server when you save. Used by the on-site agent to authenticate.',
  'integrations.fields.controllerNotes': 'Controller notes',
  'integrations.fields.controllerNotesHint': 'Optional: IP addresses, cabinet locations, anything the installer should know.',
  'integrations.fields.fromEmail': 'From email',
  'integrations.fields.fromName': 'From name',
  'integrations.fields.host': 'Host',
  'integrations.fields.port': 'Port',
  'integrations.fields.secure': 'Use TLS (port 465)',
  'integrations.fields.username': 'Username',
  'integrations.fields.password': 'Password',
  'integrations.fields.sender': 'Sender name',
  'integrations.fields.senderHint': 'Up to 11 Latin letters, digits, dots or dashes, registered with the provider first.',
  'integrations.fields.marketingOptOut': 'Opt-out line for offers',
  'integrations.fields.marketingOptOutHint': 'The line smsoffice.ge gives your sender for advertising, such as 90212 1234 - NO. Every campaign text ends with it; campaigns cannot be texted without it.',
  'enum.agentCommandType.OPEN_READER': 'Open reader',
  'enum.agentCommandType.SYNC_READERS': 'Sync readers',
  'enum.agentCommandType.PING': 'Ping',
  'enum.agentCommandType.PRINT_RECEIPT': 'Print receipt',

  'gymSettings.title': 'Settings',
  'gymSettings.description': 'Gym profile, policies and the domains your website answers on.',
  'gymSettings.tab.profile': 'Profile',
  'gymSettings.tab.sales': 'Sales',
  'gymSettings.tab.booking': 'Booking',
  'gymSettings.tab.pause': 'Freezes',
  'gymSettings.tab.access': 'Access',
  'gymSettings.tab.notifications': 'Notifications',
  'gymSettings.tab.domains': 'Domains',
  'gymSettings.tab.shifts': 'Shifts',
  'gymSettings.tab.team': 'Team',
  'gymSettings.team.title': 'Certificates',
  'gymSettings.team.description': 'Trainers and massage therapists keep their certificates under Team → Employees → Documents.',
  'gymSettings.team.requireValidCertificate': 'Hosting needs a valid certificate',
  'gymSettings.team.requireValidCertificateHint': 'A trainer or massage therapist with no certification on file that is still valid cannot take a new class or one-to-one session. Sessions already booked stay as they are.',
  'admin.apiError.CERTIFICATE_EXPIRED': 'This trainer has no valid certificate on file, so they cannot take new sessions. Choose someone else.',
  'gymSettings.shiftAccess.title': 'Working shifts',
  'gymSettings.shiftAccess.description': 'Decide what people who work in shifts can do outside their shift.',
  'gymSettings.shiftAccess.mode': 'Outside the shift',
  'gymSettings.shiftAccess.mode.OFF': 'Off',
  'gymSettings.shiftAccess.modeHint.OFF': 'Shifts never limit anyone.',
  'gymSettings.shiftAccess.mode.OFF_DUTY': 'Off duty outside the shift',
  'gymSettings.shiftAccess.modeHint.OFF_DUTY': 'They keep only their own leave, hours, clock, shifts, onboarding, the knowledge base, kudos and one-to-one requests made to them.',
  'gymSettings.shiftAccess.mode.SIGN_OUT': 'Signed out at the end of the shift',
  'gymSettings.shiftAccess.modeHint.SIGN_OUT': 'They keep only the clock and their own shifts, and the app signs them out when the shift ends.',
  'gymSettings.shiftAccess.graceBefore': 'Minutes before the shift',
  'gymSettings.shiftAccess.graceBeforeHint': 'Working access starts this long before the shift is due to begin.',
  'gymSettings.shiftAccess.graceAfter': 'Minutes after the shift',
  'gymSettings.shiftAccess.graceAfterHint': 'Working access lasts this long after the shift is due to end.',
  'gymSettings.shiftAccess.warnBefore': 'Warn before the end (minutes)',
  'gymSettings.shiftAccess.warnBeforeHint': 'How long before working access ends the app warns the person.',
  'gymSettings.shiftAccess.roles': 'Roles held to their shifts',
  'gymSettings.shiftAccess.neverHeld': 'Never held to shifts: {roles}.',
  'gymSettings.shiftAccess.noSchedule': 'A person in one of these roles with no schedule is off duty, unless they are clocked in or a manager has extended their time.',
  'gymSettings.shiftAccess.noEmployee': 'A login without an employee record cannot clock in.',
  'gymSettings.profileSaved': 'Gym profile saved',
  'gymSettings.settingSaved': 'Setting saved',
  'gymSettings.settingsSaved': 'Settings saved',
  'gymSettings.profileTitle': 'Gym profile',
  'gymSettings.profileDescription': 'Shown on the website, receipts and emails.',
  'gymSettings.legalName': 'Legal name',
  'gymSettings.gymDescription': 'Description',
  'gymSettings.address': 'Address',
  'gymSettings.city': 'City',
  'gymSettings.country': 'Country',
  'gymSettings.countryHint': 'Two-letter ISO code, e.g. GE',
  'gymSettings.timezone': 'Timezone',
  'gymSettings.currency': 'Currency',
  'gymSettings.currencyHint': 'Three-letter ISO code, e.g. GEL',
  'gymSettings.defaultLanguage': 'Default language',
  'gymSettings.saveProfile': 'Save profile',
  'gymSettings.members': 'Members',
  'gymSettings.selfRegistration': 'Allow self-registration',
  'gymSettings.selfRegistrationHint': 'Visitors can create an account from the website and buy a plan on their own.',
  'gymSettings.frontDesk': 'Front desk',
  'gymSettings.requireShift': 'Require an open shift for cash',
  'gymSettings.requireShiftHint': 'Cash sales are refused until reception opens a shift with a counted float. Card and bank transfer sales are never blocked.',
  'gymSettings.barDrawer': 'The bar keeps its own cash',
  'gymSettings.barDrawerHint': "Each branch's bar opens and closes a drawer of its own at the till, and bar cash no longer counts in reception's. Close every open shift before changing this.",
  'gymSettings.autoRenewal': 'Automatic renewal',
  'gymSettings.renewDays': 'Charge saved cards before the end date',
  'gymSettings.renewDaysHint': 'Applies to plans marked auto-renew and members who saved a card at checkout. A declined card is retried once the next day.',
  'gymSettings.daysBefore.one': '{count} day before',
  'gymSettings.daysBefore.other': '{count} days before',
  'gymSettings.refunds': 'Refunds',
  'gymSettings.approvalLimit': 'Approval limit ({currency})',
  'gymSettings.approvalLimitHint': 'A refund up to this amount goes through at once, from the front desk too. A larger one waits until an owner, admin or accountant other than the person who asked approves it. Set 0 to send every refund for approval.',
  'gymSettings.approvalLimitError': 'Enter an amount from 0 to {max}',
  'gymSettings.booking.title': 'Booking policy',
  'gymSettings.booking.description': 'When members can book classes and what happens when they cancel late.',
  'gymSettings.booking.opens': 'Booking opens (hours before)',
  'gymSettings.booking.closes': 'Booking closes (minutes before)',
  'gymSettings.booking.cutoff': 'Free cancellation until (minutes before)',
  'gymSettings.booking.max': 'Max active bookings per member',
  'gymSettings.booking.lateNoShow': 'Late cancellation counts as no-show',
  'gymSettings.booking.lateNoShowHint': 'Applies after the free cancellation window.',
  'gymSettings.booking.waitlist': 'Waitlist enabled',
  'gymSettings.booking.waitlistHint': 'Members can queue for full sessions.',
  'gymSettings.pause.title': 'Freeze policy',
  'gymSettings.pause.description': 'Limits for freezing memberships, which staff at the desk keep to as well. Individual plans can override these.',
  'gymSettings.pause.min': 'Minimum freeze (days)',
  'gymSettings.pause.max': 'Maximum freeze (days)',
  'gymSettings.pause.count': 'Freezes per membership',
  'gymSettings.pause.selfService': 'Members can freeze their own membership',
  'gymSettings.pause.selfServiceHint': 'From the member area, within these limits.',
  'gymSettings.pause.approval': "Members' freezes need staff approval",
  'gymSettings.pause.approvalHint': 'Requests show up on the Memberships page. A freeze staff make needs no approval.',
  'gymSettings.access.title': 'Door policy',
  'gymSettings.access.description': 'How strictly readers and turnstiles apply membership rules.',
  'gymSettings.access.antiPassback': 'Anti-passback (minutes)',
  'gymSettings.access.antiPassbackHint': '0 disables. Blocks a second entry with the same card within this window.',
  'gymSettings.access.newVisit': 'New visit after (hours)',
  'gymSettings.access.newVisitHint': "An entry this long after the previous one counts as a new visit for a plan's daily limit, even without an exit.",
  'gymSettings.access.grace': 'Grace days after expiry',
  'gymSettings.access.graceHint': 'Let members in for a few days after their membership ends.',
  'gymSettings.access.pending': 'Allow entry with a pending membership',
  'gymSettings.access.pendingHint': 'Useful when payments are settled at the desk.',
  'gymSettings.notifications.title': 'Notifications',
  'gymSettings.notifications.description': 'Automatic emails to members and alerts for the team.',
  'gymSettings.notifications.expiring': 'Expiry reminders (days before)',
  'gymSettings.notifications.expiringHint': 'Comma separated, e.g. 7, 1',
  'gymSettings.notifications.classReminder': 'Class reminder (minutes before)',
  'gymSettings.notifications.classReminderHint': '0 disables reminders.',
  'gymSettings.notifications.adminEmails': 'Admin notification emails',
  'gymSettings.notifications.adminEmailsHint': 'One per line. Receives contact-form messages and pause requests.',
  'gymSettings.sales.title': 'Online sales',
  'gymSettings.sales.description': 'Whether members can buy a membership themselves, on your website and in the member area.',
  'gymSettings.sales.online': 'Members can buy online',
  'gymSettings.sales.onlineHint': 'Turn this off while you are changing prices or waiting on the bank. The front desk keeps selling either way.',
  'gymSettings.sales.pausedMessage': 'What the website says instead',
  'gymSettings.sales.pausedMessageHint': 'Shown in place of every Buy button. Leave empty for the default.',
  'gymSettings.sales.vat': 'The gym charges VAT',
  'gymSettings.sales.vatHint': "Prices include VAT, so the bar's margins and profitability report count prices without it. Ask the accountant.",
  'gymSettings.sales.vatRate': 'VAT rate, %',

  'domains.added': 'Domain added — verify it once its DNS record is in place',
  'domains.primaryUpdated': 'Primary domain updated',
  'domains.removed': 'Domain removed',
  'domains.title': 'Domains',
  'domains.description': 'Hostnames that serve the public website. The primary domain is used in links and emails.',
  'domains.emptyTitle': 'No domains yet',
  'domains.emptyDescription': 'Add a custom domain below.',
  'domains.hostname': 'Hostname',
  'domains.type': 'Type',
  'domains.verification': 'Verification',
  'domains.verified': 'Verified',
  'domains.primary': 'Primary',
  'domains.verify': 'Verify',
  'domains.makePrimary': 'Make primary',
  'domains.remove': 'Remove',
  'domains.addTitle': 'Add a custom domain',
  'domains.addDescription': 'Point your own domain at the gym website. You will get DNS instructions after adding it.',
  'domains.add': 'Add domain',
  'domains.verifyTitle': 'Domain verification',
  'domains.live': 'The domain is yours. Your website opens on it once Bulk has connected it.',
  'domains.pending': 'Add the DNS record below, wait for it to spread, then verify again.',
  'domains.recordFound': '{name} record found',
  'domains.recordMissing': '{name} record missing',
  'domains.recordsToAdd': 'DNS record to add',
  'domains.removeTitle': 'Remove domain?',
  'domains.removeDescription': '{hostname} will stop serving the website.',
  'enum.domainType.SUBDOMAIN': 'Subdomain',
  'enum.domainType.CUSTOM_DOMAIN': 'Custom domain',
};

export const ka: Record<keyof typeof en, string> = {
  'adminArea.noAccessTitle': 'ამ გვერდზე წვდომა არ გაქვთ',
  'adminArea.noAccessDescription': 'სთხოვეთ დარბაზის მფლობელს ან ადმინისტრატორს, მოგცეთ საჭირო უფლება.',
  'adminArea.goBack': 'უკან დაბრუნება',
  'adminArea.nothingTitle': 'საჩვენებელი არაფერია',
  'adminArea.nothingDescription': 'თქვენს როლს ამ დარბაზში ადმინისტრირების უფლებები არ აქვს.',
  'adminArea.chooseGym': 'აირჩიეთ დარბაზი',
  'adminArea.chooseGymDescription': 'ამ ანგარიშით რამდენიმე დარბაზის მართვა შეგიძლიათ. აირჩიეთ, რომელზეც გსურთ მუშაობა.',
  'adminArea.noStaffGyms': 'ჯერ არცერთი დარბაზის პერსონალში არ ხართ.',
  'adminArea.platformConsole': 'პლატფორმის კონსოლის გახსნა',
  'adminArea.notFoundTitle': 'გვერდი ვერ მოიძებნა',
  'adminArea.notFoundDescription': 'ადმინისტრირების ასეთი გვერდი არ არსებობს.',
  'adminArea.backToDashboard': 'მთავარ დაფაზე დაბრუნება',
  'adminArea.copy': 'კოპირება',
  'adminArea.copyPrompt': 'დააკოპირეთ ეს მნიშვნელობა',

  'staff.title': 'პერსონალი',
  'staff.description': 'ადამიანები, ვისაც ადმინისტრირების ამ გვერდებზე შესვლა შეუძლია.',
  'staff.invite': 'მოწვევა',
  'staff.roleUpdated': 'როლი განახლდა',
  'staff.removed': 'თანამშრომელი პერსონალიდან მოიხსნა',
  'staff.emptyTitle': 'პერსონალი ჯერ არ არის',
  'staff.emptyDescription': 'მოიწვიეთ თქვენი გუნდი, რომ წევრებისა და ვარჯიშების მართვა შეძლონ.',
  'staff.role': 'როლი',
  'staff.since': 'დამატების თარიღი',
  'staff.you': '(თქვენ)',
  'staff.remove': 'მოხსნა',
  'staff.removeTitle': 'მოვხსნათ თანამშრომელი?',
  'staff.removeDescription': '{name} ადმინისტრირების გვერდებზე წვდომას მაშინვე დაკარგავს.',
  'staff.pendingTitle': 'მოლოდინში მყოფი მოწვევები',
  'staff.pendingDescription': 'ბმულები, რომლებიც ჯერ არ მიუღიათ. იმავე ელფოსტის ხელახლა მოწვევა წინა ბმულს ცვლის.',
  'staff.pendingEmptyTitle': 'მოლოდინში მყოფი მოწვევები არ არის',
  'staff.pendingEmptyDescription': 'მოწვეული ადამიანები აქ ჩანან, სანამ მოწვევას არ მიიღებენ.',
  'staff.invitedBy': 'მოიწვია',
  'staff.sent': 'გაიგზავნა',
  'staff.expires': 'ვადა იწურება',
  'staff.revoke': 'ანულირება',
  'staff.revoked': 'მოწვევა ანულირდა',
  'staff.revokeTitle': 'ვაანულიროთ მოწვევა?',
  'staff.revokeDescription': '{email}-ზე გაგზავნილი ბმული მაშინვე შეწყვეტს მოქმედებას.',
  'staff.inviteTitle': 'თანამშრომლის მოწვევა',
  'staff.inviteDescription': 'მიიღებს წერილს ბმულით, რომლითაც ანგარიშს შექმნის.',
  'staff.done': 'მზადაა',
  'staff.sendInvite': 'მოწვევის გაგზავნა',
  'staff.attachedExisting': 'ამ ადამიანს Bulk-ის ანგარიში უკვე ჰქონდა, ამიტომ გუნდს პირდაპირ დაემატა.',
  'staff.inviteSent': 'მოწვევა გაიგზავნა. თუ ელფოსტა ჯერ არ არის დაყენებული, ეს ბმული პირდაპირ გაუზიარეთ:',
  'staff.firstName': 'სახელი',
  'staff.lastName': 'გვარი',
  'staff.roleHint': 'დარბაზს ადმინისტრატორები აწყობენ: პარამეტრები, ინტეგრაციები, როლები და შესაძლებლობები და აუდიტის ჟურნალი მხოლოდ მათია. მფლობელებსა და დარბაზის გენერალურ მენეჯერებს დანარჩენი ყველაფრის შეცვლა შეუძლიათ; მფლობელს, დარბაზის გენერალურ მენეჯერსა და HR მენეჯერს მხოლოდ მფლობელი ან ადმინისტრატორი ამატებს. HR მენეჯერი გუნდს მართავს: პერსონალის ანგარიშებს, ჩანაწერებს, შვებულებებს, განრიგს, სამუშაო საათებსა და დაქირავებას, მაგრამ არა წევრებსა და ფინანსებს. ფილიალის მენეჯერი მართავს თავის ფილიალებსა და მათ პერსონალს; ცვლის მენეჯერი მართავს ცვლას. თანამშრომლები და მიმღების პერსონალი მიმღებზე მუშაობენ; ბუღალტრები ფინანსებს ხედავენ; ტრენერები საკუთარ ვარჯიშებს მართავენ.',
  'practice.banner': 'სავარჯიშო დარბაზი: აქაური წევრები, თანხები და კარები გამოგონილია. აქ რასაც გააკეთებთ, {gym}-ს არ შეეხება.',
  'practice.backToReal': 'რეალურ დარბაზში დაბრუნება',
  'practice.title': 'სავარჯიშო დარბაზი',
  'practice.description': 'გამოგონილი დარბაზი, სადაც ახალი თანამშრომლები ვარჯიშობენ აბონემენტების გაყიდვაში, შესვლის რეგისტრაციაში, ბარსა და თანხის დაბრუნებაში. გუნდის ყველა წევრი შედის თავისი როლით და აქ არაფერი ეხება რეალურ ფულს, წევრებს, ელფოსტასა და კარებს.',
  'practice.none': 'სავარჯიშო დარბაზი ჯერ არ არის.',
  'practice.create': 'სავარჯიშო დარბაზის შექმნა',
  'practice.created': 'სავარჯიშო დარბაზი მზადაა',
  'practice.open': 'სავარჯიშო დარბაზის გახსნა',
  'practice.reset': 'სავარჯიშო დარბაზის განახლება',
  'practice.resetTitle': 'განვაახლოთ სავარჯიშო დარბაზი?',
  'practice.resetBody': 'სტაჟიორების ყველა მოქმედება შეიცვლება ახალი გამოგონილი დარბაზით. რეალურ დარბაზს არაფერი ეხება.',
  'practice.resetDone': 'სავარჯიშო დარბაზი განახლდა',
  'practice.summary.one': 'შექმნილია {date} · {count} გამოგონილი წევრი',
  'practice.summary.other': 'შექმნილია {date} · {count} გამოგონილი წევრი',
  'practice.cards': 'გამოგონილი ბარათები მიმღებზე და კარზე საცდელად: PRACTICE-0001 – {last}.',
  'practice.edit': 'ციფრების შეცვლა',
  'practice.delete': 'სავარჯიშო დარბაზის წაშლა',
  'practice.deleteTitle': 'წავშალოთ სავარჯიშო დარბაზი?',
  'practice.deleteBody': 'გუნდი მასში ვეღარ შევა და მისი გამოგონილი წევრები, გაყიდვები და ვიზიტები წაიშლება. რეალურ დარბაზს არაფერი შეეხება, ახლის შექმნა კი ნებისმიერ დროს შეგიძლიათ.',
  'practice.deleted': 'სავარჯიშო დარბაზი წაიშალა',
  'practice.chooseFigures': 'ჯერ ციფრების არჩევა',
  'practice.makeup.createTitle': 'სავარჯიშო დარბაზის შექმნა',
  'practice.makeup.editTitle': 'სავარჯიშო დარბაზის შეცვლა',
  'practice.makeup.rebuildNote': 'შენახვისას სავარჯიშო დარბაზი ამ ციფრებით თავიდან აიწყობა: ყველაფერი, რაც იქ გაკეთდა, ჩანაცვლდება. რეალურ დარბაზს არაფერი შეეხება.',
  'practice.makeup.saveRebuild': 'შენახვა და თავიდან აწყობა',
  'practice.makeup.members': 'წევრები',
  'practice.makeup.branches': 'ფილიალები',
  'practice.makeup.active': 'აქტიური აბონემენტით',
  'practice.makeup.endingSoon': 'კვირაში სრულდება',
  'practice.makeup.expired': 'ვადაგასული აბონემენტით',
  'practice.makeup.withoutMembership': 'აბონემენტის გარეშე',
  'practice.makeup.withBalance': 'ბარის ბალანსით',
  'practice.makeup.total.one': 'სულ {count} გამოგონილი წევრი',
  'practice.makeup.total.other': 'სულ {count} გამოგონილი წევრი',
  'practice.makeup.whole': 'გამოიყენეთ მთელი რიცხვები, 0 ან მეტი.',
  'practice.makeup.branchesRange': 'სავარჯიშო დარბაზს 1-დან {max}-მდე ფილიალი აქვს.',
  'practice.makeup.membersRange': 'სავარჯიშო დარბაზს 1-დან {max}-მდე წევრი ჰყავს.',
  'practice.makeup.balanceTooMany': 'ბალანსიანი წევრები წევრების რაოდენობას აღემატება.',
  'practice.inside': 'ახლა სავარჯიშო დარბაზში ხართ. მას რეალური დარბაზიდან ქმნიან და ანახლებენ.',
  'viewAs.label': 'ადმინის ნახვა როლით',
  'viewAs.self': '{role} (თქვენ)',
  'viewAs.as': 'ხედვა: {role}',
  'viewAs.banner': 'ახლა მუშაობთ როლით „{role}“: ხედავთ და შეგიძლიათ მხოლოდ ის, რაც ამ როლს შეუძლია. ცვლილებები მაინც თქვენს სახელზე ჩაიწერება.',
  'viewAs.back': 'დაბრუნება: {role}',
  'viewAs.member.option': 'წევრის კაბინეტის ნახვა…',
  'viewAs.member.title': 'წევრის კაბინეტის ნახვა',
  'viewAs.member.description': 'აირჩიეთ სავარჯიშო დარბაზის გამოგონილი წევრი. მის კაბინეტს დაინახავთ ისე, როგორც ის ხედავს, და შეძლებთ იმას, რაც მას შეუძლია. რასაც გააკეთებთ, თქვენს სახელზე ჩაიწერება.',
  'viewAs.member.search': 'ძებნა სახელით ან წევრის ნომრით',
  'viewAs.member.none': 'ასეთი წევრი არ მოიძებნა.',
  'viewAs.member.number': '№ {number}',
  'viewAs.member.banner': 'წევრის კაბინეტს ხედავთ როგორც {name} (№ {number}), სავარჯიშო დარბაზის გამოგონილი წევრი. რასაც აქ გააკეთებთ, თქვენს სახელზე ჩაიწერება.',
  'viewAs.member.stop': 'ნახვის შეწყვეტა',

  'abilities.changed': 'შეცვლილია',
  'abilities.turnedOn': '{ability}: ჩართულია როლისთვის „{role}“',
  'abilities.turnedOff': '{ability}: გამორთულია როლისთვის „{role}“',
  'abilities.menu.edit': 'ბარის მენიუს რედაქტირება',
  'abilities.menu.edit.hint': 'პროდუქტებისა და კატეგორიების დამატება, შეცვლა, დამალვა და წაშლა. ყველა ფილიალი ერთი მენიუდან ყიდის.',
  'abilities.website.publish': 'ვებსაიტის გამოქვეყნება',
  'abilities.website.publish.hint': 'ვებსაიტზე შეტანილი ცვლილებების ვიზიტორებისთვის გამოქვეყნება.',
  'abilities.legal.publish': 'იურიდიული გვერდების გამოქვეყნება',
  'abilities.legal.publish.hint': 'წესებისა და პირობების, კონფიდენციალურობის პოლიტიკისა და სხვა დოკუმენტების გამოქვეყნება.',
  'abilities.campaigns.run': 'აქციების მართვა',
  'abilities.campaigns.run.hint': 'ფასდაკლების აქციების შექმნა, შეცვლა და დასრულება.',
  'abilities.campaigns.email': 'აქციების ელფოსტით გაგზავნა',
  'abilities.campaigns.email.hint': 'მიმდინარე აქციის გაგზავნა იმ წევრებთან, ვინც დათანხმდა შეთავაზებებს ელფოსტით, დარბაზის საკუთარი ელფოსტის ანგარიშიდან.',
  'abilities.campaigns.sms': 'აქციების SMS-ით გაგზავნა',
  'abilities.campaigns.sms.hint': 'მიმდინარე აქციის გაგზავნა იმ წევრებთან, ვინც დათანხმდა შეთავაზებებს SMS-ით; თითოეული SMS დარბაზის ხარჯია.',
  'abilities.staff.manage': 'პერსონალის ანგარიშების მართვა თავის ფილიალებში',
  'abilities.staff.manage.hint': 'თავის ფილიალებში დაქვემდებარებული თანამშრომლების მოწვევა, შეცვლა და მოხსნა.',
  'abilities.payments.refund': 'გადახდების დაბრუნება',
  'abilities.payments.refund.hint': 'დაბრუნების მოთხოვნების დამტკიცება ან უარყოფა და გადახდის პირდაპირ დაბრუნება.',
  'abilities.wallet.correct': 'ბალანსის შესწორება',
  'abilities.wallet.correct.hint': 'წევრის ბალანსში შეცდომის გასწორება; მიზეზი ცვლილებასთან ერთად ინახება.',
  'abilities.refunds.request': 'დაბრუნების მოთხოვნის გაგზავნა',
  'abilities.refunds.request.hint': 'გადახდის დაბრუნების მოთხოვნა; მას ამტკიცებს ის, ვისაც დაბრუნება შეუძლია.',
  'abilities.wallet.top_up': 'ბალანსის შევსება',
  'abilities.wallet.top_up.hint': 'მიმღებთან თანხის მიღება და წევრის ბალანსზე დამატება.',
  'abilities.bar.sell': 'ბარში გაყიდვა',
  'abilities.bar.sell.hint': 'გაყიდვების გატარება ბარის სალაროში.',
  'abilities.bar.refund': 'ბარის გაყიდვების დაბრუნება',
  'abilities.bar.refund.hint': 'ბარში გაყიდულზე თანხის დაბრუნება.',
  'abilities.bar.stock': 'მარაგის აღწერა',
  'abilities.bar.stock.hint': 'მიწოდებების მიღება და თაროზე არსებულის აღწერა.',
  'abilities.classes.edit': 'ყველა ვარჯიშის დაგეგმვა',
  'abilities.classes.edit.hint': 'ნებისმიერი ვარჯიშის, სლოტისა და სესიის დამატება და შეცვლა ნებისმიერი ტრენერისთვის. მის გარეშე ტრენერი მხოლოდ საკუთარ ვარჯიშებს გეგმავს.',
  'abilities.finance.close_month': 'ფინანსური თვის დახურვა',
  'abilities.finance.close_month.hint': 'თვის დახურვა, როცა ის დასრულდება და ყველა დავალება შესრულებული ან გამოტოვებულია.',
  'abilities.expenses.drawer': 'ხარჯების გადახდა სალაროდან',
  'abilities.expenses.drawer.hint': 'მცირე ხარჯების ნაღდი ანგარიშსწორება ღია სალაროდან; ცვლა შემდეგ ამდენით ნაკლებ ნაღდ ფულს ელოდება.',
  'abilities.trainers.roster': 'ტრენერების სიის მართვა',
  'abilities.trainers.roster.hint': 'ტრენერების დამატება და დეაქტივაცია, მათი სახელების, კონტაქტების, სპეციალობებისა და თანამშრომლის ფოტოს მითითება.',
  'abilities.trainers.website': 'ტრენერების ვებპროფილების მართვა',
  'abilities.trainers.website.hint': 'ვებსაიტის ფოტო, სახელები და ბიოგრაფიები ორ ენაზე, ვინ ჩანს საიტზე და რა თანმიმდევრობით.',
  'abilities.schedules.manage': 'განრიგების მართვა თავის ფილიალებში',
  'abilities.schedules.manage.hint': 'თავის ფილიალებში გუნდის განრიგის ნახვა, თანამშრომლებისთვის განრიგის მინიჭება, ცალკეული დღეების შეცვლა და ცვლების გაცვლის დამტკიცება.',
  'abilities.leave.decide': 'შვებულების გადაწყვეტა თავის ფილიალებში',
  'abilities.leave.decide.hint': 'თავის ფილიალებში დაქვემდებარებული თანამშრომლების შვებულების დამტკიცება ან უარყოფა და მათთვის შვებულების აღრიცხვა.',
  'abilities.plans.edit': 'აბონემენტის პაკეტების რედაქტირება',
  'abilities.plans.edit.hint': 'აბონემენტის პაკეტების შექმნა, შეცვლა და დაარქივება: სახელი, ფასი, ხანგრძლივობა, საათები და ჯგუფური ვარჯიშები. ამის ჩართვა მფლობელსაც შეუძლია პაკეტების გვერდიდან.',
  'abilities.appointments.book_for_member': 'წევრებისთვის სესიების დაჯავშნა',
  'abilities.appointments.book_for_member.hint': 'წევრის ჩაწერა საკუთარ ინდივიდუალურ დროზე, მაშინვე დადასტურებით. სესია წევრის პაკეტიდან ჩამოიჭრება, ან ის მიმღებზე იხდის.',
  'abilities.tags.manage': 'ტეგების სიის მართვა',
  'abilities.tags.manage.hint': 'დარბაზის წევრთა ტეგების დამატება, გადარქმევა, ფერის შეცვლა და წაშლა და არა მხოლოდ წევრებისთვის მინიჭება.',

  'audit.title': 'აუდიტის ჟურნალი',
  'audit.description': 'პერსონალის, ინტეგრაციებისა და სისტემის მიერ შეტანილი ყველა ცვლილება.',
  'audit.entity': 'ობიექტი',
  'audit.entityPlaceholder': 'მაგ. member, membership, plan',
  'audit.action': 'მოქმედება',
  'audit.actionPlaceholder': 'მაგ. member.created',
  'audit.emptyTitle': 'აუდიტის ჩანაწერები არ არის',
  'audit.emptyDescription': 'ამ ფილტრებს ჯერ არაფერი ემთხვევა.',
  'audit.when': 'დრო',
  'audit.actor': 'შემსრულებელი',
  'audit.details': 'დეტალები',
  'audit.system': 'სისტემა',
  'audit.metadata': 'მეტამონაცემები',

  'integrations.title': 'ინტეგრაციები',
  'integrations.description': 'დააკავშირეთ სერვისები, რომლებზეც დარბაზი მუშაობს. თითოეული ამოქმედებამდე მოწმდება.',
  'integrations.blurb.PAYMENT': 'აბონემენტების ონლაინ გადახდა, დაბრუნებები და ბანკიდან მიღებული შეტყობინებები.',
  'integrations.blurb.ACCESS_CONTROL': 'ტურნიკეტები, კარები და წამკითხველები, რომლებიც შესასვლელთან აბონემენტს ამოწმებენ.',
  'integrations.blurb.EMAIL': 'ქვითრები, შეხსენებები და პერსონალის მოწვევები.',
  'integrations.blurb.SMS': 'წევრებს SMS-ით ატყობინებს გაუქმებულ ან შეცვლილ ვარჯიშებზე, ვადის ამოწურვაზე და უგზავნის შესვლის ბმულს.',
  'integrations.smsTestNumber': 'მობილურის ნომერი სატესტო SMS-ისთვის',
  'integrations.smsTestSend': 'სატესტო SMS-ის გაგზავნა',
  'integrations.smsTestHint': 'ნამდვილი SMS, რომელიც ჩვეულებრივად ღირს. აჩვენებს, რომ გამგზავნის სახელი დამტკიცებულია, სანამ წევრები მას დაეყრდნობიან.',
  'integrations.emailQueued': 'წერილები რიგში ელოდება და გაიგზავნება, როგორც კი საკუთარ ელფოსტის ანგარიშს დააკავშირებთ და შეამოწმებთ.',
  'integrations.emailViaPlatform': 'სანამ საკუთარ ელფოსტის ანგარიშს დააკავშირებთ და შეამოწმებთ, წერილები Bulk-ის გავლით გაიგზავნება მისამართიდან {fromEmail}, გამგზავნის სახელით „{gymName} via {brand}“. პასუხები მივა დარბაზის ელფოსტაზე, თუ ის მითითებულია გვერდზე პარამეტრები → პროფილი.',
  'integrations.yourGym': 'თქვენი დარბაზი',
  'integrations.testConnected': 'დაკავშირებულია: {message}',
  'integrations.testFailed': 'ტესტი ვერ შესრულდა: {message}',
  'integrations.disconnected': 'ინტეგრაცია გაითიშა',
  'integrations.enabled': 'ჩართული',
  'integrations.connectedAt': 'დაკავშირდა',
  'integrations.lastChecked': 'ბოლო შემოწმება',
  'integrations.never': 'არასდროს',
  'integrations.notConfigured': 'ჯერ არ არის დაყენებული.',
  'integrations.webhookUrl': 'Webhook URL',
  'integrations.configure': 'დაყენება',
  'integrations.reconfigure': 'ხელახლა დაყენება',
  'integrations.test': 'ტესტი',
  'integrations.logs': 'ჟურნალი',
  'integrations.disconnect': 'გათიშვა',
  'integrations.disconnectTitle': 'გავთიშოთ ინტეგრაცია?',
  'integrations.disconnectDescription': 'პროვაიდერი გამოირთვება, მისი სტატუსი განულდება და შენახული მონაცემები წაიშლება, ამიტომ ის თავიდან უნდა დააყენოთ. ადგილობრივი აგენტი არ იმუშავებს, სანამ ახალი ტოკენით ხელახლა არ დააყენებთ.',
  'integrations.logsTitle': '{kind} — ჟურნალი',
  'integrations.logsEmpty': 'ჟურნალში ჩანაწერები ჯერ არ არის',
  'integrations.when': 'დრო',
  'integrations.level': 'დონე',
  'integrations.operation': 'ოპერაცია',
  'integrations.message': 'შეტყობინება',
  'integrations.duration': 'ხანგრძლივობა',
  'integrations.durationMs': '{ms} მწმ',
  'integrations.agentCommands': 'აგენტის ბრძანებები',
  'integrations.agentCommandsDescription': 'ადგილობრივი დაშვების აგენტისთვის რიგში ჩაყენებული ბრძანებები, უახლესი პირველია.',
  'integrations.agentCommandsEmptyTitle': 'ბრძანებები ჯერ არ არის',
  'integrations.agentCommandsEmptyDescription': 'დისტანციური გაღებისა და სინქრონიზაციის ბრძანებები აქ გაგზავნისთანავე გამოჩნდება.',
  'integrations.created': 'შეიქმნა',
  'integrations.type': 'ტიპი',
  'integrations.acknowledged': 'დადასტურდა',
  'integrations.result': 'შედეგი',
  'integrations.configSaved': 'კონფიგურაცია შენახულია',
  'integrations.continue': 'გაგრძელება',
  'integrations.saveConfig': 'კონფიგურაციის შენახვა',
  'integrations.testAgain': 'ხელახლა შემოწმება',
  'integrations.testConnection': 'კავშირის შემოწმება',
  'integrations.done': 'მზადაა',
  'integrations.configureTitle': 'დაყენება: {kind}',
  'integrations.current': 'მიმდინარე',
  'integrations.secretsNote': 'საიდუმლო მონაცემები დაშიფრულად ინახება. მიმდინარე მნიშვნელობის შესანარჩუნებლად ველი ცარიელი დატოვეთ.',
  'integrations.savedRunTest': '{provider} · შენახულია. ჩასართავად შეამოწმეთ კავშირი.',
  'integrations.connectionOk': 'კავშირი გამართულია',
  'integrations.connectionFailed': 'კავშირი ვერ დამყარდა',
  'integrations.webhookHint': 'დაარეგისტრირეთ ეს callback URL ბანკის მერჩანტის პორტალში.',
  'integrations.smsReportUrl': 'მიწოდების ანგარიშების მისამართი',
  'integrations.smsReportHint': 'სთხოვეთ smsoffice.ge-ს, მიწოდების ანგარიშები ამ მისამართზე გამოგზავნოს. მანამდე Bulk თავად ამოწმებს თითოეულ SMS-ს და მიზეზი, რის გამოც SMS ვერ მივიდა, უცნობი რჩება.',
  'integrations.texts': 'SMS-ები',
  'integrations.textsTitle': 'გაგზავნილი SMS-ები',
  'smsLog.when': 'როდის',
  'smsLog.member': 'წევრი',
  'smsLog.text': 'ტექსტი',
  'smsLog.delivery': 'მივიდა ტელეფონზე',
  'smsLog.noReport': 'ანგარიში ჯერ არ არის',
  'smsLog.nextTry': 'შემდეგი ცდა {when}',
  'smsLog.problemsOnly': 'მხოლოდ წარუმატებელი და მიუწოდებელი SMS-ები',
  'smsLog.empty': 'SMS-ები ჯერ არ არის',
  'smsLog.emptyHint': 'აქ გამოჩნდება SMS-ები ვარჯიშებზე, აბონემენტებზე, მოწვევებსა და შეთავაზებებზე, როცა გაიგზავნება.',
  'smsLog.noProblems': 'ყველა SMS მივიდა ან ჯერ გზაშია',
  'integrations.stepProvider': 'პროვაიდერი',
  'integrations.stepSettings': 'პარამეტრები',
  'integrations.generatedOnSave': 'შენახვისას შეიქმნება',
  'integrations.keepSecret': 'შენახული საიდუმლო მნიშვნელობის შესანარჩუნებლად ველი ცარიელი დატოვეთ.',
  'integrations.agent.title': 'ადგილობრივი აგენტის დაყენება',
  'integrations.agent.install': 'დააინსტალირეთ {path} დარბაზის ქსელში მდებარე კომპიუტერზე, საიდანაც Gantner-ის კონტროლერები მისაწვდომია.',
  'integrations.agent.env': 'აგენტის პროცესისთვის დააყენეთ ეს გარემოს ცვლადები:',
  'integrations.agent.tokenOnce': 'დააკოპირეთ ტოკენი ახლავე: ის მხოლოდ ახლა ჩანს და მეორედ აღარ გამოჩნდება. წინა ტოკენი აღარ მუშაობს, ამიტომ დარბაზში დაყენებული აგენტი გამორთული დარჩება, სანამ მას ამ ახალ ტოკენს არ მიაწვდით.',
  'integrations.agent.tokenMasked': 'აგენტის ტოკენი დაშიფრულად ინახება და აღარასდროს ჩანს. აგენტისთვის ტოკენის მისაღებად შეცვალეთ ის: Bulk შექმნის ახალს, ერთხელ გაჩვენებთ, მიმდინარე ტოკენი კი იმავე წამს შეწყვეტს მუშაობას.',
  'integrations.agent.rotate': 'ტოკენის შეცვლა და ჩვენება',
  'integrations.agent.rotateTitle': 'შევცვალოთ აგენტის ტოკენი?',
  'integrations.agent.rotateDescription': 'ახალი ტოკენი მიმდინარეს ეგრევე ჩაანაცვლებს. დარბაზში დაყენებული აგენტი არ იმუშავებს, სანამ მას ახალ ტოკენს არ მიაწვდით. ახალი ტოკენი დადასტურებისთანავე ერთხელ გამოჩნდება.',
  'integrations.agent.rotated': 'აგენტის ახალი ტოკენი შეიქმნა',
  'admin.apiError.NOT_AN_AGENT': 'დაშვების კონტროლი ადგილობრივ აგენტთან არ არის დაკავშირებული, ამიტომ შესაცვლელი აგენტის ტოკენი არ არსებობს. ჯერ აგენტი დააყენეთ.',
  'integrations.agent.driver': 'აირჩიეთ დრაივერი. ტურნიკეტების სიმულაციისთვის დატოვეთ {mock}, ან GANTNER/Lapis-ის კონტროლერთან ადგილობრივი RabbitMQ-ით დასაკავშირებლად მიუთითეთ {rabbit} და ასევე დააყენეთ:',
  'integrations.agent.controllerIds': 'ობიექტის (facility) ID, გამღები თანამშრომლის ID და თითოეული ტურნიკეტის მოწყობილობის ID და IP მოძებნეთ კონტროლერის (Lapis) კონფიგურაციაში. RabbitMQ-ის პაროლი საზიარო ფაილებში არ შეინახოთ.',
  'integrations.agent.start': 'გაუშვით აგენტი. ის წამკითხველებს ავტომატურად დაარეგისტრირებს; ისინი გამოჩნდება გვერდზე დაშვების კონტროლი → წამკითხველები.',
  'integrations.agent.test': 'ზემოთ გაუშვით კავშირის ტესტი — ის წარმატებით დასრულდება, როგორც კი აგენტი პირველ სიგნალს (heartbeat) გამოაგზავნის.',
  'integrations.providers.paymentMock': 'ტესტირებისთვის. წევრი ხვდება სატესტო ბანკის გვერდზე, სადაც შედეგს თქვენ ირჩევთ.',
  'integrations.providers.tbc': 'TBC-ის ონლაინ გადახდა (ბარათები, Apple Pay, Google Pay).',
  'integrations.providers.bog': 'Bank of Georgia iPay — ონლაინ გადახდა.',
  'integrations.providers.accessMock': 'სიმულირებული წამკითხველები დაშვების პროცესის შესამოწმებლად, მოწყობილობების გარეშე.',
  'integrations.providers.enviso': 'Enviso-ს ღრუბლოვანი დაშვების კონტროლი.',
  'integrations.providers.gantner': 'Gantner GT7 ტურნიკეტები დარბაზის ქსელში, რომლებსაც Bulk-ის დაშვების აგენტი ადგილობრივი RabbitMQ-ით აკავშირებს.',
  'integrations.providers.console': 'წერილები არ იგზავნება — მხოლოდ ჟურნალში იწერება.',
  'integrations.providers.smtp': 'ნებისმიერი SMTP სერვერი (Google Workspace, Office 365, Mailgun, …).',
  'integrations.providers.resend': 'Resend-ის API ტრანზაქციული წერილებისთვის.',
  'integrations.providers.consoleSms': 'SMS-ები ჟურნალში იწერება და არ იგზავნება.',
  'integrations.providers.smsoffice': 'ქართული SMS სერვისი smsoffice.ge. საჭიროა ანგარიში ბალანსით და დარეგისტრირებული გამგზავნის სახელი.',
  'integrations.fields.autoComplete': 'გადახდების ავტომატური დასრულება',
  'integrations.fields.autoCompleteHint': 'სატესტო ბანკის გვერდი გამოტოვდება და გადახდა მაშინვე გადახდილად მოინიშნება.',
  'integrations.fields.apiKey': 'API გასაღები',
  'integrations.fields.clientId': 'კლიენტის ID (Client ID)',
  'integrations.fields.clientSecret': 'კლიენტის საიდუმლო (Client secret)',
  'integrations.fields.baseUrl': 'API-ის საბაზო URL',
  'integrations.fields.callbackAllowedIps': 'Callback-ისთვის დაშვებული IP მისამართები',
  'integrations.fields.callbackAllowedIpsHint': 'გამოყავით მძიმით. სხვა მისამართებიდან შემოსული webhook-ები უარყოფილი იქნება.',
  'integrations.fields.tokenUrl': 'OAuth ტოკენის URL',
  'integrations.fields.verifyCallbackSignature': 'Callback-ის ხელმოწერის შემოწმება',
  'integrations.fields.simulateProviderErrors': 'პროვაიდერის შეცდომების სიმულაცია',
  'integrations.fields.apiSecret': 'API საიდუმლო (API secret)',
  'integrations.fields.tenantKey': 'ტენანტის გასაღები (Tenant key)',
  'integrations.fields.environment': 'გარემო',
  'integrations.fields.agentToken': 'აგენტის ტოკენი',
  'integrations.fields.agentTokenHint': 'სერვერი ქმნის შენახვისას. ადგილობრივი აგენტი მას ავთენტიფიკაციისთვის იყენებს.',
  'integrations.fields.controllerNotes': 'შენიშვნები კონტროლერებზე',
  'integrations.fields.controllerNotesHint': 'არასავალდებულო: IP მისამართები, სამონტაჟო კარადების მდებარეობა და ყველაფერი, რაც ინსტალატორმა უნდა იცოდეს.',
  'integrations.fields.fromEmail': 'გამგზავნის ელფოსტა',
  'integrations.fields.fromName': 'გამგზავნის სახელი',
  'integrations.fields.host': 'ჰოსტი',
  'integrations.fields.port': 'პორტი',
  'integrations.fields.secure': 'TLS-ის გამოყენება (პორტი 465)',
  'integrations.fields.username': 'მომხმარებლის სახელი',
  'integrations.fields.password': 'პაროლი',
  'integrations.fields.sender': 'გამგზავნის სახელი',
  'integrations.fields.senderHint': 'მაქსიმუმ 11 ლათინური ასო, ციფრი, წერტილი ან ტირე, წინასწარ დარეგისტრირებული პროვაიდერთან.',
  'integrations.fields.marketingOptOut': 'უარის თქმის ხაზი შეთავაზებებისთვის',
  'integrations.fields.marketingOptOutHint': 'ხაზი, რომელსაც smsoffice.ge აძლევს თქვენს გამგზავნს რეკლამისთვის, მაგ. 90212 1234 - NO. ყველა აქციის SMS მით სრულდება; მის გარეშე აქციებს SMS-ით ვერ გაგზავნით.',
  'enum.agentCommandType.OPEN_READER': 'წამკითხველის გაღება',
  'enum.agentCommandType.SYNC_READERS': 'წამკითხველების სინქრონიზაცია',
  'enum.agentCommandType.PING': 'კავშირის შემოწმება (ping)',
  'enum.agentCommandType.PRINT_RECEIPT': 'ქვითრის ბეჭდვა',

  'gymSettings.title': 'პარამეტრები',
  'gymSettings.description': 'დარბაზის პროფილი, წესები და დომენები, რომლებზეც თქვენი ვებსაიტი იხსნება.',
  'gymSettings.tab.profile': 'პროფილი',
  'gymSettings.tab.sales': 'გაყიდვები',
  'gymSettings.tab.booking': 'ჯავშნები',
  'gymSettings.tab.pause': 'გაყინვა',
  'gymSettings.tab.access': 'დაშვება',
  'gymSettings.tab.notifications': 'შეტყობინებები',
  'gymSettings.tab.domains': 'დომენები',
  'gymSettings.tab.shifts': 'ცვლები',
  'gymSettings.tab.team': 'გუნდი',
  'gymSettings.team.title': 'სერტიფიკატები',
  'gymSettings.team.description': 'მწვრთნელებისა და მასაჟისტების სერტიფიკატები ინახება აქ: გუნდი → თანამშრომლები → დოკუმენტები.',
  'gymSettings.team.requireValidCertificate': 'სესიისთვის საჭიროა მოქმედი სერტიფიკატი',
  'gymSettings.team.requireValidCertificateHint': 'მწვრთნელი ან მასაჟისტი, რომელსაც მოქმედი სერტიფიკატი არ აქვს ატვირთული, ახალ ჯგუფურ ან ინდივიდუალურ სესიას ვერ ჩაატარებს. უკვე დაჯავშნილი სესიები უცვლელი რჩება.',
  'admin.apiError.CERTIFICATE_EXPIRED': 'ამ მწვრთნელს მოქმედი სერტიფიკატი არ აქვს, ამიტომ ახალ სესიებს ვერ ატარებს. აირჩიეთ სხვა.',
  'gymSettings.shiftAccess.title': 'სამუშაო ცვლები',
  'gymSettings.shiftAccess.description': 'განსაზღვრეთ, რა შეუძლიათ ცვლაში მომუშავე თანამშრომლებს თავიანთი ცვლის გარეთ.',
  'gymSettings.shiftAccess.mode': 'ცვლის გარეთ',
  'gymSettings.shiftAccess.mode.OFF': 'გამორთულია',
  'gymSettings.shiftAccess.modeHint.OFF': 'ცვლა არავის ზღუდავს.',
  'gymSettings.shiftAccess.mode.OFF_DUTY': 'ცვლის გარეთ არ არიან მორიგეობაზე',
  'gymSettings.shiftAccess.modeHint.OFF_DUTY': 'მათთვის ღია რჩება მხოლოდ საკუთარი შვებულება, საათები, მოსვლისა და წასვლის აღრიცხვა, ცვლები, ადაპტაცია, ცოდნის ბაზა, მადლობები და მათთვის გაგზავნილი ინდივიდუალური სესიების მოთხოვნები.',
  'gymSettings.shiftAccess.mode.SIGN_OUT': 'ცვლის დასრულებისას სისტემიდან გამოდიან',
  'gymSettings.shiftAccess.modeHint.SIGN_OUT': 'მათთვის ღია რჩება მხოლოდ მოსვლისა და წასვლის აღრიცხვა და საკუთარი ცვლები; ცვლის დასრულებისას აპი სისტემიდან გამოიყვანს.',
  'gymSettings.shiftAccess.graceBefore': 'წუთები ცვლამდე',
  'gymSettings.shiftAccess.graceBeforeHint': 'სამუშაო წვდომა ცვლის დაწყებამდე ამდენი ხნით ადრე იწყება.',
  'gymSettings.shiftAccess.graceAfter': 'წუთები ცვლის შემდეგ',
  'gymSettings.shiftAccess.graceAfterHint': 'სამუშაო წვდომა ცვლის დასრულების შემდეგ ამდენ ხანს გრძელდება.',
  'gymSettings.shiftAccess.warnBefore': 'გაფრთხილება დასრულებამდე (წუთი)',
  'gymSettings.shiftAccess.warnBeforeHint': 'სამუშაო წვდომის დასრულებამდე რამდენი ხნით ადრე აფრთხილებს აპი თანამშრომელს.',
  'gymSettings.shiftAccess.roles': 'როლები, რომლებსაც ცვლა ზღუდავს',
  'gymSettings.shiftAccess.neverHeld': 'ცვლა არასოდეს ზღუდავს: {roles}.',
  'gymSettings.shiftAccess.noSchedule': 'ამ როლების თანამშრომელი, რომელსაც გრაფიკი არ აქვს, ცვლის გარეთაა, თუ არ აქვს მოსვლა დაფიქსირებული ან მენეჯერმა დრო არ გაუგრძელა.',
  'gymSettings.shiftAccess.noEmployee': 'ანგარიში თანამშრომლის ჩანაწერის გარეშე მოსვლას ვერ დააფიქსირებს.',
  'gymSettings.profileSaved': 'დარბაზის პროფილი შენახულია',
  'gymSettings.settingSaved': 'პარამეტრი შენახულია',
  'gymSettings.settingsSaved': 'პარამეტრები შენახულია',
  'gymSettings.profileTitle': 'დარბაზის პროფილი',
  'gymSettings.profileDescription': 'ჩანს ვებსაიტზე, ქვითრებსა და წერილებში.',
  'gymSettings.legalName': 'იურიდიული დასახელება',
  'gymSettings.gymDescription': 'აღწერა',
  'gymSettings.address': 'მისამართი',
  'gymSettings.city': 'ქალაქი',
  'gymSettings.country': 'ქვეყანა',
  'gymSettings.countryHint': 'ორასოიანი ISO კოდი, მაგ. GE',
  'gymSettings.timezone': 'დროის სარტყელი',
  'gymSettings.currency': 'ვალუტა',
  'gymSettings.currencyHint': 'სამასოიანი ISO კოდი, მაგ. GEL',
  'gymSettings.defaultLanguage': 'ნაგულისხმევი ენა',
  'gymSettings.saveProfile': 'პროფილის შენახვა',
  'gymSettings.members': 'წევრები',
  'gymSettings.selfRegistration': 'თვითრეგისტრაციის დაშვება',
  'gymSettings.selfRegistrationHint': 'ვიზიტორებს შეუძლიათ ვებსაიტზე ანგარიშის შექმნა და პაკეტის დამოუკიდებლად ყიდვა.',
  'gymSettings.frontDesk': 'მიმღები',
  'gymSettings.requireShift': 'ნაღდი ფულისთვის ღია ცვლის მოთხოვნა',
  'gymSettings.requireShiftHint': 'ნაღდი ფულით გაყიდვა შეუძლებელია, სანამ მიმღები ცვლას დათვლილი საწყისი თანხით არ გახსნის. ბარათით და საბანკო გადარიცხვით გაყიდვა არასდროს იბლოკება.',
  'gymSettings.barDrawer': 'ბარს საკუთარი სალარო აქვს',
  'gymSettings.barDrawerHint': 'თითოეული ფილიალის ბარი სალაროში საკუთარ ცვლას ხსნის და ხურავს, და ბარის ნაღდი ფული მიმღების სალაროში აღარ ითვლება. ცვლილებამდე დახურეთ ყველა ღია ცვლა.',
  'gymSettings.autoRenewal': 'ავტომატური განახლება',
  'gymSettings.renewDays': 'შენახული ბარათებიდან თანხის ჩამოჭრა დასრულების თარიღამდე',
  'gymSettings.renewDaysHint': 'ეხება ავტომატური განახლებით მონიშნულ პაკეტებს და წევრებს, რომლებმაც გადახდისას ბარათი შეინახეს. თუ ბარათი უარყოფილია, მეორე დღეს კიდევ ერთხელ ვცდით.',
  'gymSettings.daysBefore.one': '{count} დღით ადრე',
  'gymSettings.daysBefore.other': '{count} დღით ადრე',
  'gymSettings.refunds': 'დაბრუნებები',
  'gymSettings.approvalLimit': 'დამტკიცების ლიმიტი ({currency})',
  'gymSettings.approvalLimitHint': 'ამ თანხამდე დაბრუნება მაშინვე სრულდება, მიმღებიდანაც. უფრო დიდი დაბრუნება ელოდება, სანამ მას დაამტკიცებს მფლობელი, ადმინისტრატორი ან ბუღალტერი — ოღონდ არა ის, ვინც მოითხოვა. მიუთითეთ 0, რომ ყველა დაბრუნება დასამტკიცებლად გაიგზავნოს.',
  'gymSettings.approvalLimitError': 'შეიყვანეთ თანხა 0-დან {max}-მდე',
  'gymSettings.booking.title': 'ჯავშნის წესები',
  'gymSettings.booking.description': 'როდის შეუძლიათ წევრებს ვარჯიშზე ჩაწერა და რა ხდება, თუ გვიან გააუქმებენ.',
  'gymSettings.booking.opens': 'ჩაწერა იხსნება (საათით ადრე)',
  'gymSettings.booking.closes': 'ჩაწერა იხურება (წუთით ადრე)',
  'gymSettings.booking.cutoff': 'უფასო გაუქმების ვადა (წუთით ადრე)',
  'gymSettings.booking.max': 'აქტიური ჯავშნების მაქსიმუმი ერთ წევრზე',
  'gymSettings.booking.lateNoShow': 'გვიანი გაუქმება ითვლება გამოუცხადებლობად',
  'gymSettings.booking.lateNoShowHint': 'მოქმედებს უფასო გაუქმების ვადის გასვლის შემდეგ.',
  'gymSettings.booking.waitlist': 'მოლოდინის სია ჩართულია',
  'gymSettings.booking.waitlistHint': 'წევრებს შეუძლიათ სავსე სესიებზე მოლოდინის სიაში ჩაწერა.',
  'gymSettings.pause.title': 'გაყინვის წესები',
  'gymSettings.pause.description': 'აბონემენტების გაყინვის ლიმიტები, რომლებიც მიმღებზე მომუშავე პერსონალზეც ვრცელდება. ცალკეულ პაკეტს შეუძლია მათი შეცვლა.',
  'gymSettings.pause.min': 'მინიმალური გაყინვა (დღე)',
  'gymSettings.pause.max': 'მაქსიმალური გაყინვა (დღე)',
  'gymSettings.pause.count': 'გაყინვების რაოდენობა ერთ აბონემენტზე',
  'gymSettings.pause.selfService': 'წევრებს შეუძლიათ საკუთარი აბონემენტის გაყინვა',
  'gymSettings.pause.selfServiceHint': 'წევრის კაბინეტიდან, ამ ლიმიტების ფარგლებში.',
  'gymSettings.pause.approval': 'წევრების გაყინვას სჭირდება პერსონალის დამტკიცება',
  'gymSettings.pause.approvalHint': 'მოთხოვნები გამოჩნდება გვერდზე „აბონემენტები“. პერსონალის მიერ გაყინვას დამტკიცება არ სჭირდება.',
  'gymSettings.access.title': 'შესვლის წესები',
  'gymSettings.access.description': 'რამდენად მკაცრად იყენებენ წამკითხველები და ტურნიკეტები აბონემენტის წესებს.',
  'gymSettings.access.antiPassback': 'განმეორებითი შესვლის აკრძალვა (წუთი)',
  'gymSettings.access.antiPassbackHint': '0 — გამორთულია. ამ ინტერვალში იმავე ბარათით მეორე შესვლა იბლოკება.',
  'gymSettings.access.newVisit': 'ახალი ვიზიტი (საათის შემდეგ)',
  'gymSettings.access.newVisitHint': 'შესვლა, რომელიც წინადან ამდენი ხნის შემდეგ ხდება, პაკეტის დღიური ლიმიტისთვის ახალ ვიზიტად ითვლება, გასვლის გარეშეც.',
  'gymSettings.access.grace': 'საშეღავათო დღეები ვადის გასვლის შემდეგ',
  'gymSettings.access.graceHint': 'წევრების შემოშვება აბონემენტის დასრულებიდან კიდევ რამდენიმე დღე.',
  'gymSettings.access.pending': 'შესვლის დაშვება მოლოდინში მყოფი აბონემენტით',
  'gymSettings.access.pendingHint': 'გამოსადეგია, როცა გადახდა მიმღებზე ხდება.',
  'gymSettings.notifications.title': 'შეტყობინებები',
  'gymSettings.notifications.description': 'ავტომატური წერილები წევრებს და შეტყობინებები გუნდს.',
  'gymSettings.notifications.expiring': 'შეხსენება ვადის გასვლამდე (დღით ადრე)',
  'gymSettings.notifications.expiringHint': 'გამოყავით მძიმით, მაგ. 7, 1',
  'gymSettings.notifications.classReminder': 'ვარჯიშის შეხსენება (წუთით ადრე)',
  'gymSettings.notifications.classReminderHint': '0 შეხსენებებს გამორთავს.',
  'gymSettings.notifications.adminEmails': 'ადმინისტრატორის შეტყობინებების ელფოსტები',
  'gymSettings.notifications.adminEmailsHint': 'თითო ხაზზე ერთი. იღებს საკონტაქტო ფორმის შეტყობინებებს და პაუზის მოთხოვნებს.',
  'gymSettings.sales.title': 'ონლაინ გაყიდვები',
  'gymSettings.sales.description': 'შეუძლიათ თუ არა წევრებს აბონემენტის თავად ყიდვა თქვენს ვებსაიტზე და წევრის კაბინეტში.',
  'gymSettings.sales.online': 'წევრებს შეუძლიათ ონლაინ ყიდვა',
  'gymSettings.sales.onlineHint': 'გამორთეთ, როცა ფასებს ცვლით ან ბანკს ელოდებით. მიმღები გაყიდვას ნებისმიერ შემთხვევაში აგრძელებს.',
  'gymSettings.sales.pausedMessage': 'რას აჩვენებს ვებსაიტი სანაცვლოდ',
  'gymSettings.sales.pausedMessageHint': 'ჩანს ყიდვის ყველა ღილაკის ნაცვლად. ნაგულისხმევი ტექსტისთვის დატოვეთ ცარიელი.',
  'gymSettings.sales.vat': 'დარბაზი დღგ-ის გადამხდელია',
  'gymSettings.sales.vatHint': 'ფასები დღგ-ს შეიცავს, ამიტომ ბარის მარჟა და მომგებიანობის ანგარიში ითვლის ფასებს დღგ-ის გარეშე. ჰკითხეთ ბუღალტერს.',
  'gymSettings.sales.vatRate': 'დღგ-ის განაკვეთი, %',

  'domains.added': 'დომენი დაემატა — დაადასტურეთ, როცა მისი DNS ჩანაწერი განთავსდება',
  'domains.primaryUpdated': 'მთავარი დომენი განახლდა',
  'domains.removed': 'დომენი წაიშალა',
  'domains.title': 'დომენები',
  'domains.description': 'ჰოსტები, რომლებზეც საჯარო ვებსაიტი იხსნება. მთავარი დომენი გამოიყენება ბმულებსა და წერილებში.',
  'domains.emptyTitle': 'დომენები ჯერ არ არის',
  'domains.emptyDescription': 'დაამატეთ საკუთარი დომენი ქვემოთ.',
  'domains.hostname': 'ჰოსტი',
  'domains.type': 'ტიპი',
  'domains.verification': 'დადასტურება',
  'domains.verified': 'დადასტურდა',
  'domains.primary': 'მთავარი',
  'domains.verify': 'დადასტურება',
  'domains.makePrimary': 'მთავრად დაყენება',
  'domains.remove': 'წაშლა',
  'domains.addTitle': 'საკუთარი დომენის დამატება',
  'domains.addDescription': 'მიმართეთ საკუთარი დომენი დარბაზის ვებსაიტზე. დამატების შემდეგ მიიღებთ DNS-ის ინსტრუქციებს.',
  'domains.add': 'დომენის დამატება',
  'domains.verifyTitle': 'დომენის დადასტურება',
  'domains.live': 'დომენი თქვენია. ვებსაიტი მასზე გაიხსნება, როგორც კი Bulk მას დააკავშირებს.',
  'domains.pending': 'დაამატეთ ქვემოთ მოცემული DNS ჩანაწერი, დაელოდეთ მის გავრცელებას და ხელახლა დაადასტურეთ.',
  'domains.recordFound': '{name} ჩანაწერი ნაპოვნია',
  'domains.recordMissing': '{name} ჩანაწერი არ არის',
  'domains.recordsToAdd': 'დასამატებელი DNS ჩანაწერი',
  'domains.removeTitle': 'წავშალოთ დომენი?',
  'domains.removeDescription': '{hostname} ვებსაიტს აღარ გახსნის.',
  'enum.domainType.SUBDOMAIN': 'ქვედომენი',
  'enum.domainType.CUSTOM_DOMAIN': 'საკუთარი დომენი',
};
